import { DocumentsValidationModule } from '@/components/modules/DocumentsValidation/DocumentsValidation';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_DOCUMENTS_VALIDATION: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.DOCUMENTS_VALIDATION,
  // showIfAllowedProduct: ApplicationType.IKEA_CARD, // TODO
  schemesByRoles: [
    {
      roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.THIRD_PARTY_VALIDATION, APP_ROLES.AGENT],
      titleTextId: 'DOCUMENTS_VALIDATION',
      widgets: [],
    },
  ],

  sections: [
    {
      textId: undefined,
      module: (
        <DocumentsValidationModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.THIRD_PARTY_VALIDATION,
              APP_USER_TYPES.AGENT,
            ],
          }}
        />
      ),
    },
  ],
};
